import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import { compose } from "redux";
import { Field, Form, withFormik } from "formik";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { func, arrayOf, string, shape, bool } from "prop-types";
import Notification from "pages/_components/Notification";
import { selectors, actions } from "reducers/checks";
import { echeqShape } from "util/checks";
import * as i18n from "util/i18n";
import Col from "react-bootstrap/lib/Col";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import CreateFrequentDesitinationModal from "pages/forms/_components/CreateFrequentDesetinationModal";
import Yup from "yup";
import { selectors as sessionSelectors } from "reducers/session";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import { actions as notificationActions } from "reducers/notification";
import DrawerModal from "pages/_components/drawer/DrawerModal";
import AddBeneficiary from "pages/checks/Echeqs/EcheqActions/AddBeneficiary";
import classNames from "classnames";
import * as configUtils from "util/config";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { Box, Tooltip, Icon } from "@ui-kit/components/index.es";

const FORM_ID = "echeqs";

const statuses = [
    { value: "NOM", label: "Nominal" },
    { value: "NEG", label: "Negociación" },
];

class EndorseEcheqStep1 extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        echeqAction: shape({
            action: string.isRequired,
            echeqList: arrayOf(echeqShape),
            specialAttribute: string.isRequired,
            confirmGoBackPath: string,
        }).isRequired,
        endorseData: shape({
            beneficiary: shape({}),
        }).isRequired,
        setValues: func.isRequired,
        history: shape({
            listen: func.isRequired,
        }).isRequired,
        activeEnvironment: shape({
            permissions: shape({
                frequentDestination: bool,
            }),
        }).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        frequentVisible: false,
        showDrawer: false,
        contentDrawer: "",
    };

    componentWillMount = () => {
        const { echeqAction, setValues, endorseData } = this.props;

        if (!echeqAction.action) {
            this.handleBack();
            return;
        }

        const values = endorseData?.endorseData || { type: "NOM" };
        setValues({ ...values, reference: values.reference || "", referencevalue: values.referencevalue || "" });
        this.applyV3ShellLayout();
    };

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, echeqAction } = this.props;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.echeqAction !== echeqAction
        ) {
            this.applyV3ShellLayout();
        }
    }

    closeModal = () => {
        this.setState({ frequentVisible: false });
    };

    openModal = () => {
        const { endorseData } = this.props;

        if (!endorseData?.beneficiary?.reference) {
            this.setState({ frequentVisible: true });
        }
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell, echeqAction } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push(echeqAction.confirmGoBackPath || "/echeqs"));
        } else {
            dispatch(goBack());
        }
    };

    cleanBeneficiary = () => {
        const { dispatch } = this.props;
        dispatch(actions.beneficiaryEcheq({}, "checks/BENEFICIARY_ENDORSE_ECHEQ_DATA"));
    };

    componentWillUnmount = () => {
        const { dispatch, embeddedInV3Shell, history } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: history?.location?.pathname || "" });
        }
        this.listenHistory();
    };

    getShellTitleKey = () => {
        const { echeqAction } = this.props;
        if (!echeqAction?.action) {
            return "";
        }
        return echeqAction.echeqList?.length > 1
            ? `${FORM_ID}.${echeqAction.action.toLowerCase()}.title.multi`
            : `${FORM_ID}.${echeqAction.action.toLowerCase()}.title`;
    };

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, echeqAction } = this.props;
        const titleKey = this.getShellTitleKey();

        if (!titleKey) {
            return;
        }
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            syncDesktopShellHeader: true,
            scopes: ["echeqs"],
            titleKey,
            goBackPath: echeqAction.confirmGoBackPath || "/echeqs",
        });
    };

    listenHistory = () => {
        const { history, echeqAction } = this.props;

        const unlisten = history?.listen((location) => {
            const nextPath = location?.pathname;
            const regExp = /.*\/echeqs\/action\/endorse.*/;
            if (!regExp.test(nextPath) && echeqAction?.echeqList?.length < 2) {
                // No limpio el beneficiario si la lista de echeqs es > a 1,
                // ya que en multiples necesito la info del beneficiario
                this.cleanBeneficiary();
            }
            unlisten();
        });
    };

    selectBeneficiary = (beneficiary) => {
        const { dispatch } = this.props;
        const document =
            beneficiary?.document || `${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`;

        dispatch(
            actions.beneficiaryEcheq(
                {
                    document,
                    reference: beneficiary?.headline || beneficiary?.recipientName,
                },
                "checks/BENEFICIARY_ENDORSE_ECHEQ_DATA",
            ),
        );

        this.setState({ frequentVisible: false });
    };

    closeDrawer = () => {
        this.setState({ showDrawer: false });
    };

    renderHeader = () => {
        const { echeqAction, isDesktop } = this.props;
        const title =
            echeqAction?.echeqList?.length > 1
                ? `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title.multi`
                : `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title`;

        if (isDesktop) {
            return (
                <>
                    <Head onBack={this.handleBack} />
                    <Head title={title} centerContentClassName="p-0" />
                </>
            );
        }

        if (isUxDashboardImprovementsEnabled() && !isDesktop) {
            return null;
        }

        return (
            <Head
                headerClassName="blue-main-header-mobile"
                titleClassName="w-100"
                onBack={this.handleBack}
                title={title}
                emptyRightOption
            />
        );
    };

    render() {
        const { endorseData, isDesktop, activeEnvironment, embeddedInV3Shell } = this.props;
        const { showDrawer, contentDrawer, frequentVisible } = this.state;
        const showTooltipReference = configUtils.getBoolean("frontend.show.tooltip.reference", false);

        if (endorseData?.beneficiary?.reference && showDrawer) {
            this.closeDrawer();
        }

        return (
            <>
                <CreateFrequentDesitinationModal
                    isVisible={frequentVisible}
                    onClick={this.selectBeneficiary}
                    closeModal={this.closeModal}
                    isDesktop={isDesktop}
                />
                <div className="admin-detail-head px-0">{this.renderHeader()}</div>
                {!embeddedInV3Shell && <Notification scopeToShow="echeqs" />}
                <MainContainer className="main-container px-0">
                    <div className="above-the-fold">
                        {showDrawer && (
                            <DrawerModal
                                content={contentDrawer}
                                width={isDesktop ? "30%" : "100vw"}
                                showDrawerRemote={showDrawer}
                                isDesktop={isDesktop}
                                navStyle="default pt-3"
                                title={`${isDesktop ? "" : "echeqs.add.beneficiary.title"}`}
                                headerContent={
                                    !isDesktop && (
                                        <div className="toolbar-item view-title align-self-center mx-0">
                                            <I18n
                                                id="echeqs.add.beneficiary.title"
                                                component="h1"
                                                componentProps={{
                                                    className: "title-content header-mobile-title-background-blue mb-0",
                                                }}
                                            />
                                        </div>
                                    )
                                }
                                closeRemotely={() => this.closeDrawer()}
                            />
                        )}
                        <Container
                            className="flex-grow align-items-center container-white"
                            gridClassName="form-content">
                            <Col xs={12} md={8} lg={6} style={{ alignItems: "center" }} className="px-0 py-2 d-flex">
                                <Col xs={isDesktop ? 7 : 8} style={{ display: "flex", alignItems: "center" }}>
                                    <span className={classNames("control-label")}>
                                        {i18n.get(`${FORM_ID}.beneficiary.data`)}
                                    </span>
                                </Col>
                                <Col
                                    xs={isDesktop ? 5 : 4}
                                    className="justify-content-end"
                                    style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button
                                        className={`btn-outline plus-button ${
                                            !isDesktop ? "radius mr-4 small-svg bold-svg mt-25" : ""
                                        }`}
                                        onClick={() =>
                                            this.setState({
                                                showDrawer: true,
                                                contentDrawer: (
                                                    <AddBeneficiary
                                                        type="checks/BENEFICIARY_ENDORSE_ECHEQ_DATA"
                                                        isDesktop={isDesktop}
                                                    />
                                                ),
                                            })
                                        }>
                                        <Image src="images/plus.svg" />
                                        {isDesktop && (
                                            <I18n
                                                id={`${FORM_ID}.add.beneficiary`}
                                                componentProps={{ style: { lineHeight: 1 } }}
                                            />
                                        )}
                                    </Button>
                                    {activeEnvironment?.permissions.frequentDestination ? (
                                        <Button
                                            bsStyle="link"
                                            image="images/frequent-destination.svg"
                                            className={classNames("no-shadow d-flex w-auto", {
                                                "m-0 p-0 justify-content-end svg25": !isDesktop,
                                                "svg30 mr-3": isDesktop,
                                            })}
                                            onClick={this.openModal}
                                        />
                                    ) : (
                                        undefined
                                    )}
                                </Col>
                            </Col>
                        </Container>
                        {endorseData?.beneficiary?.reference && (
                            <Container
                                className="flex-grow align-items-center container-white my-2 with-padding"
                                gridClassName="form-content">
                                <Col xs={12} md={8} lg={6}>
                                    <div className="space-between">
                                        <div>
                                            <span className="control-label" style={{ marginRight: "0.5rem" }}>
                                                {i18n.get(`${FORM_ID}.reference.beneficiary`)}
                                            </span>
                                            <span className="data-desc">
                                                {endorseData?.beneficiary?.reference?.replaceAll("#", "Ñ")}
                                            </span>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn-link"
                                            onClick={() => this.cleanBeneficiary()}>
                                            <Image
                                                src="images/cross-mobile-blue.svg"
                                                styles={{ width: "25px", height: "25px" }}
                                            />
                                        </button>
                                    </div>
                                </Col>
                            </Container>
                        )}
                        <Form>
                            <Container
                                className="flex-grow align-items-center container-white my-2"
                                gridClassName="form-content">
                                <Col xs={12} md={8} lg={6} className="px-0">
                                    <Col xs={12}>
                                        <Col xs={12} md={6} className={classNames("pl-0 py-1", { "pr-0": !isDesktop })}>
                                            <Field
                                                component={Selector}
                                                disabled={!endorseData?.beneficiary?.reference}
                                                options={[...statuses]}
                                                idForm={FORM_ID}
                                                name="type"
                                                isRequired
                                                isDisabled={!endorseData?.beneficiary?.reference}
                                                customPlaceholder={i18n.get("new.check.checksTypes.placeholder")}
                                            />
                                        </Col>
                                    </Col>
                                    <Col xs={12} className="endorse-echeq-reference">
                                        <Col xs={12} md={6} className={classNames("pl-0 py-1", { "pr-0": !isDesktop })}>
                                            <Field
                                                component={TextField}
                                                hidePlaceholder
                                                disabled={!endorseData?.beneficiary?.reference}
                                                idForm={FORM_ID}
                                                name="reference"
                                                type="text"
                                                isDisabled={!endorseData?.beneficiary?.reference}
                                                infoMsg={
                                                    showTooltipReference ? (
                                                        <Tooltip
                                                            id="endorse-echeq-reference-tooltip"
                                                            label={configUtils.get(
                                                                "frontend.show.tooltip.reference.text",
                                                                "Aquí se puede registrar un motivo (ej. orden y número de compra).",
                                                            )}
                                                            placement={isDesktop ? "right" : "top"}
                                                            maxW={!isDesktop ? "13rem" : undefined}>
                                                            <Box align="center" mx={8}>
                                                                <Icon
                                                                    name="Info"
                                                                    variant="outline"
                                                                    size={20}
                                                                    color="primary-color"
                                                                    css={{ margin: 8 }}
                                                                />
                                                            </Box>
                                                        </Tooltip>
                                                    ) : (
                                                        undefined
                                                    )
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={6} className={classNames("pr-0 py-1", { "pl-0": !isDesktop })}>
                                            <Field
                                                component={TextField}
                                                hidePlaceholder
                                                disabled={!endorseData?.beneficiary?.reference}
                                                idForm={FORM_ID}
                                                name="referencevalue"
                                                type="text"
                                                isDisabled={!endorseData?.beneficiary?.reference}
                                            />
                                        </Col>
                                    </Col>
                                </Col>
                            </Container>
                            <Container className="flex-grow align-items-center" gridClassName="form-content">
                                <Col xs={12} md={4} className={classNames({ "mt-1": !isDesktop, "mt-8": isDesktop })}>
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Button
                                            type="submit"
                                            bsStyle="primary"
                                            label="global.continue"
                                            disabled={!endorseData?.beneficiary?.reference}
                                            style={{ marginTop: "2rem" }}
                                        />
                                    </Container>
                                </Col>
                            </Container>
                        </Form>
                    </div>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    option: selectors.getEcheqOption(state),
    echeqAction: selectors.getEcheqsToDoActions(state),
    endorseData: selectors.getEcheqsEndorseData(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ type: "NOM", reference: "", referencevalue: "" }),
        validationSchema: () =>
            Yup.object().shape({
                type: Yup.string().required(i18n.get(`${FORM_ID}.error.required`)),
            }),
        handleSubmit: (form, formikBag) => {
            const { dispatch, endorseData } = formikBag.props;

            if (!endorseData?.beneficiary?.reference) {
                dispatch(
                    notificationActions.showNotification(i18n.get(`${FORM_ID}.empty.beneficiary`), "error", ["echeqs"]),
                );
            } else {
                dispatch(actions.endorseEcheqData(form));
                dispatch(push("/echeqs/action/endorse/confirm"));
            }
        },
    }),
)(EndorseEcheqStep1);
